import * as tslib_1 from "tslib";
export default function getRecipientsFromWellViewState(wellViewState) {
    var e_1, _a;
    var emails = [];
    if (wellViewState && wellViewState.recipients) {
        try {
            for (var _b = tslib_1.__values(wellViewState.recipients), _c = _b.next(); !_c.done; _c = _b.next()) {
                var recipient = _c.value;
                var emailAddress = recipient.persona.EmailAddress;
                if (emailAddress && emailAddress.ItemId && emailAddress.MailboxType == 'PrivateDL') {
                    // VSO 18660: make sure send to PDL correctly
                    // Follow jsMVVM behavior, ChangeKey needs to be null
                    emails.push({
                        Name: emailAddress.Name,
                        RoutingType: emailAddress.RoutingType,
                        MailboxType: emailAddress.MailboxType,
                        ItemId: {
                            Id: emailAddress.ItemId.Id,
                            ChangeKey: null,
                        },
                        EmailAddressIndex: emailAddress.EmailAddressIndex,
                        RelevanceScore: emailAddress.RelevanceScore || 0,
                    });
                }
                else {
                    emails.push(recipient.persona.EmailAddress);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return emails;
}
//# sourceMappingURL=getRecipientsFromWellViewState.js.map